<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      width="478px"
      center
      class="add-cooperation-dialog"
      custom-class="tool-workbench-dialog"
      @close="$emit('close-dialog')"
    >
      <h4 slot="title" class="dialog-title">设置编辑权限</h4>
      <p class="remark">仅指定的成员可查看和编辑您的项目作品</p>
      <div
        v-loading="loading"
        class="team-group"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
        <div class="team-group-header">
          <div class="cell-1">团队成员 ({{ memberList.length + 1 }})</div>
          <div class="cell-2">
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange"
              >全选</el-checkbox
            >
          </div>
        </div>
        <div class="team-group-body">
          <!-- $.handleAssetsUrl(avatarGroup[creatorIndex]) -->
          <div class="team-group-body_cell cell-fixed">
            <div class="lf">
              <el-avatar
                size="small"
                :src="
                  getCreatorAvatar !== null
                    ? $handleAssetsUrl(getCreatorAvatar)
                    : require('../../assets/userCenter/defaulthead_bg.png')
                "
                class="avatar-img"
              ></el-avatar>
              <span class="user-name">{{ getCreatorNickname }}</span>
            </div>
            <el-checkbox class="selection" disabled :value="true">{{
              ""
            }}</el-checkbox>
          </div>
          <el-checkbox-group
            v-model="checkedCooperation"
            @change="handleCheckedChange"
          >
            <div
              v-for="(item, i) in memberList"
              :key="i"
              class="team-group-body_cell"
              :class="
                item.cooperatorId === currentCooperatorId ? 'is-active' : ''
              "
              @click.self="selected(item.cooperatorId)"
            >
              <div class="lf">
                <el-avatar
                  size="small"
                  :src="
                    item.cooperator.headImgUrl === null
                      ? require('../../assets/userCenter/defaulthead_bg.png')
                      : $handleAssetsUrl(item.cooperator.headImgUrl)
                  "
                  class="avatar-img"
                ></el-avatar>
                <span class="user-name">{{ item.cooperator.nickname }}</span>
              </div>
              <el-checkbox class="selection" :label="item.cooperatorId">{{
                ""
              }}</el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <p class="remark">复制链接，邀请新成员加入团队并参与协作该项目</p>
      <bench-clipboard
        :clipContent="inviteCodeUrl"
        style="width: 375px"
      ></bench-clipboard>
      <p class="warn-info">*链接仅在24小时内有效</p>
      <div class="dialog-footer">
        <div
          class="submit-btn"
          @click="onConfirmCooperator(currentDraft.draftid)"
        >
          确定
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      class="is-cooperation-dialog"
      :visible.sync="isCooperatorDialogVisible"
      width="464px"
      :modal="false"
      center
    >
      <div>
        发起协作将会把草稿转为协作草稿，你可以在,
        <a href="/dashboard/team/cooperation" target="_blank">团队-协作草稿</a
        >中找到它。是否发起协作
      </div>
      <div class="check">
        <el-checkbox v-model="checkboxValue"></el-checkbox>
        <span>之后不再提示</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="btn"
          @click="(isCooperatorDialogVisible = false), (visible = true)"
          >再想想</el-button
        >
        <el-button
          class="btn"
          type="primary"
            :disabled="isDisabled"
          @click="setCooperatorRight(currentDraft.draftid)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    BenchClipboard: () => import("./clipboard-btn"),
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    privateDraft: {
      type: Boolean,
      default: true,
    },
    closeDialog: {
      type: Function,
      default: () => {
        return false;
      },
    },
    currentDraft: {
      type: Object,
      default: () => { },
    },
    type: {
      type: String,
      default: "cooperation",
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    loadType: {}
  },
  data() {
    let visible = this.value;
    return {
      visible,
      checkboxValue: true,
      isCooperatorDialogVisible: false,
      // isIndeterminate: false, // 是否选中部分
      avatarGroup: [], // 头像组
      nicknameGroup: [], // 昵称组
      userIdGroup: [], // userId组
      memberList: [], // 成员列表
      memberIds: [], // 成员列表id
      loading: false, // loading加载
      creatorIndex: -1, // 创建者索引
      currentCooperatorId: -1, // 选中行的索引
      checkAll: false, // 是否全选
      currentIdex: 2, // 当前选中
      initCheckedCooperation: [], //初始化选中状态的协作成员
      needRemovedMembers: [], // 需要移除的成员
      checkedCooperation: [], // 选中的
      inviteCodeUrl: "", // 邀请码
      isDisabled: false,
    };
  },
  computed: {
    ...mapGetters([
      "inviteCode",
      "teamMembers",
      "joinCooDraftStateInfo",
      "removeCooperatorStateInfo",
      "cooperationType",
    ]),
    // ...mapActions("wbDraft", ["fetchDraftList"]),
    getCreatorAvatar() {
      return this.type === "cooperation"
        ? this.avatarGroup[this.creatorIndex]
        : this.currentDraft &&
        this.currentDraft.userInfo &&
        this.currentDraft.userInfo.headImgUrl;
    },
    getCreatorNickname() {
      return this.type === "cooperation"
        ? this.nicknameGroup[this.creatorIndex]
        : this.currentDraft &&
        this.currentDraft.userInfo &&
        this.currentDraft.userInfo.nickname;
    },
  },
  watch: {
    async value(val) {
      this.visible = val;
      if (!val) return;
      setTimeout(() => {
        let div = document.getElementsByClassName("v-modal")[0];
        if (
          div &&
          div.style.zIndex > 1000 &&
          div.parentNode.localName === "body"
        ) {
          div.parentNode.removeChild(div);
        }
      }, 50);
      setTimeout(() => {
        let div = document.getElementsByClassName("v-modal")[0];
        if (
          div &&
          div.style.zIndex > 1000 &&
          div.parentNode.localName === "body"
        ) {
          div.parentNode.removeChild(div);
        }
      }, 100);

      this.loading = true;

      let { data } = await this.$http.get("/api/user/draft", {
        params: {
          pIndex: 1,
          fPage: 100,
          id: this.currentDraft.draftid,
        },
      });
      if (data.code === 200 && this.loadType !== 'blank') {
        this.currentDraft.shareDraft = data.data.shareDraft;
        if (
          this.currentDraft.shareDraft &&
          this.currentDraft.shareDraft.shareDarftVersion &&
          this.currentDraft.shareDraft.shareDarftVersion.userInfo
        ) {
          let item = this.currentDraft.shareDraft.shareDarftVersion.userInfo;
          if (item.headImgUrl) item.headImgUrl = item.headImgUrl.split(",");
          if (item.nickname) item.nickname = item.nickname.split(",");
          if (item.userId) item.userId = item.userId.split(",");
        }
      }

      // 获取邀请码
      await this.fetchInviteCode({
        draftId: this.currentDraft.draftid,
      });
      // 获取成员列表
      await this.fetchTeamMembers();
      // if (this.type === "cooperation") {
      //   let _userInfo = this.currentDraft.shareDarftVersion.userInfo;
      //   // 当前协作者头像组
      //   this.avatarGroup = _userInfo.headImgUrl;

      //   // 当前协作者昵称组
      //   this.nicknameGroup = _userInfo.nickname;

      //   // 当前协作者id组
      //   this.userIdGroup = _userInfo.userId;
      // } else
      // console.log(
      //   "userInfo",
      //   this.currentDraft.shareDraft.shareDarftVersion.userInfo
      // );

      if (
        this.type === "mydraft" &&
        this.currentDraft.shareDraft !== null &&
        this.currentDraft.shareDraft.shareDarftVersion !== null
      ) {
        let _userInfo1 = this.currentDraft.shareDraft.shareDarftVersion
          .userInfo;
        // 当前协作者头像组
        this.avatarGroup = _userInfo1.headImgUrl;

        // 当前协作者昵称组
        this.nicknameGroup = _userInfo1.nickname;

        // 当前协作者id组
        this.userIdGroup = _userInfo1.userId;
      } else {
        // 当前协作者头像组
        this.avatarGroup = [this.currentDraft.userInfo.headImgUrl];
        // 当前协作者昵称组
        this.nicknameGroup = [this.currentDraft.userInfo.nickname];
        // 当前协作者id组
        this.userIdGroup = [this.currentDraft.userId];
      }

      if (this.loadType === 'blank') {
        this.userIdGroup = [this.currentDraft.userId];
      }

      // 创建者索引
      let _userId = this.currentDraft.userId;
      this.creatorIndex = this.userIdGroup.findIndex((item) => {
        return item == _userId;
      });

      // 初始化值
      this.memberIds = [];
      this.checkedCooperation = [];
      this.initCheckedCooperation = [];

      // 过滤成员列表中除去自己其他的成员
      this.memberList = this.teamMembers.filter((item) => {
        if (item.cooperatorId != _userId) {
          this.memberIds.push(item.cooperatorId);
        }
        return item.cooperatorId != _userId;
      });

      // 已选中的
      this.memberList.map((item) => {
        if (this.userIdGroup.indexOf(item.cooperatorId + "") == -1) return;
        this.checkedCooperation.push(item.cooperatorId);
        this.initCheckedCooperation.push(item.cooperatorId);
      });

      // 初始化选中状态的变化
      this.selectionStatus(this.checkedCooperation.length);
      this.loading = false;

      // 邀请链接

      this.inviteCodeUrl =
        window.location.host +
        "?inviteCode=" +
        this.inviteCode +
        "&inviteType=2";
    },
    visible(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    ...mapActions([
      "fetchInviteCode",
      "fetchTeamMembers",
      "fetchJoinCooDraft",
      "removeCooperator",
      "fetchTeamCooTempList",
    ]),
    // ...mapActions("wbDraft", ["fetchDraftList"]),

    /**
     * 全选
     * @param {Object} val
     */
    handleCheckAllChange(val) {
      this.checkedCooperation = val ? this.memberIds : [];
      // this.isIndeterminate = false;
    },

    /**
     * 单个选中
     * @param {Object} value
     */
    handleCheckedChange(value) {
      let checkedCount = value.length;
      let _len = this.memberIds.length;
      this.checkAll = checkedCount === _len;
      // this.isIndeterminate = checkedCount > 0 && checkedCount < _len;
    },
    /**
     * 选中行
     * @param {Object} cooperatorId
     */
    selected(cooperatorId) {
      this.currentCooperatorId = cooperatorId;
      let _slen;
      if (this.checkedCooperation.indexOf(cooperatorId) == -1) {
        this.checkedCooperation.push(cooperatorId); // 不在就选中添加到数组中
        _slen = this.checkedCooperation.length;
        this.selectionStatus(_slen);
      } else {
        let _index = this.checkedCooperation.findIndex(
          (item) => item === cooperatorId
        ); // 在就从数组中移除
        this.checkedCooperation.splice(_index, 1);
        _slen = this.checkedCooperation.length;
        this.selectionStatus(_slen);
      }
    },
    async onConfirmCooperator(_id) {
      if (this.privateDraft) {
        const c = window.localStorage.getItem("isCooperatorDialogVisible");
        if (c) {
        await  this.setCooperatorRight(_id);
        } else {
          this.visible = false;
          this.isCooperatorDialogVisible = true;
        }
      } else if (this.cooperationType >= 0) {
        await this.AddCooperatorMember(_id);
      }
    },
    /**
     * 设置编辑权限
     * @param {type} _id 协作项目id
     * 过滤出需要添加的添加/删除的成员数量
     * 1.增加/删除 数量都为0
     * 2.删除数量>0
     * 3.增加数量>0
     */
    async setCooperatorRight(_id) {
      this.isDisabled=false;
      if (this.isCooperatorDialogVisible) {
        window.localStorage.setItem("isCooperatorDialogVisible", "true");
      }
      await this.AddCooperatorMember(_id);
      this.isCooperatorDialogVisible=false;
      let { origin, pathname } = window.location;
      window.location.assign(
        origin +
        pathname +
        "?time=" +
        new Date().getTime() +
        "#/" +
        this.currentDraft.draftid
      );
    },
    async AddCooperatorMember(_id) {
      this.filterMembers();
      let _rLen = this.needRemovedMembers.length,
        _aLen = this.needAddMembers.length;
      // 不做任何操作
      if (_rLen === 0 && _aLen === 0) {

      };
      // 只有删除没有添加
      if (_rLen > 0 && _aLen === 0) {
        await this.removeCooperatorAction(
          this.needRemovedMembers.join(","),
          _id
        );
        //this.reflashList();
        this.$emit("close-dialog"); //关闭弹框
        this.fetchTeamMembers(); // 刷新团队成员
        return;
      }
      // 只有添加没有删除
      if (_rLen === 0 && _aLen > 0) {
        sensors.track("", {
          team_id: _id,
          collaboration_validity: "",
        });
        let addCount = await this.addCooperateAction(
          this.needAddMembers.join(","),
          _id
        );
        //this.reflashList();
        //console.log('addCount',addCount);
        this.$emit("close-dialog", { addCount }); //关闭弹框
        this.fetchTeamMembers(); // 刷新团队成员
        return;
      }
      // 既有添加又有删除成员操作
      if (_rLen > 0 && _aLen > 0) {
        await this.removeCooperatorAction(
          this.needRemovedMembers.join(","),
          _id
        );
        sensors.track("", {
          team_id: _id,
          collaboration_validity: "",
        });
        let addCount = await this.addCooperateAction(
          this.needAddMembers.join(","),
          _id
        );
        //this.reflashList();
        //console.log('addCount',addCount)
        this.$emit("close-dialog", { addCount }); //关闭弹框
        this.fetchTeamMembers(); // 刷新团队成员
      }
    },

    /**
     * 过滤团队成员
     */
    filterMembers() {
      this.needRemovedMembers = [];
      this.needAddMembers = [];
      let arr1 = this.initCheckedCooperation,
        arr2 = this.checkedCooperation;
      // 需要移除的成员
      this.needRemovedMembers = arr1.filter((item) => {
        return arr2.indexOf(item) === -1;
      });
      // 需要添加的成员
      this.needAddMembers = arr2.filter((item) => {
        return arr1.indexOf(item) === -1;
      });
      if (
        this.needRemovedMembers.length === 0 &&
        this.needAddMembers.length === 0
      ) {
        this.$emit("close-dialog"); //关闭弹框
        return;
      }
      //console.log("this.needRemovedMembers", this.needRemovedMembers);
      //console.log("this.needAddMembers", this.needAddMembers);
    },

    /**
     * 添加团队成员操作
     * @param {type} _str 需要添加的团队成员
     * @param {type} _id 项目id
     */
    async addCooperateAction(_str, _id) {
      await this.fetchJoinCooDraft({
        userId: _str,
        id: _id,
      });
      // 需要添加的
      let _aLen;
      if (this.joinCooDraftStateInfo.code === 200) {
        // 成功添加的
        _aLen = this.joinCooDraftStateInfo.data;
        this.$message({
          message: `成功添加${ _aLen }个用户`,
          type: "success",
        });
      } else {
        this.$message.error(this.joinCooDraftStateInfo.msg);
      }
      //console.log('addCooperateAction', _aLen);
      return _aLen;
    },

    /**
     * 删除团队成员操作
     * @param {type} _str 需要删除的团队成员
     * @param {type} _id 项目id
     */
    async removeCooperatorAction(_str, _id) {
      await this.removeCooperator({
        userId: _str,
        id: _id,
      });
      // 需要删除的数据
      let _len1 = this.needRemovedMembers.length,
        _len;
      if (this.removeCooperatorStateInfo.code === 200) {
        // 成功删除
        _len = this.removeCooperatorStateInfo.data.length;
        if (_len === 0 && _len1 !== _len) {
          this.$message.error("编辑中状态用户移除失败，请稍后重试。");
        } else if (_len1 === _len) {
          this.$message({
            message: `成功移除${ _len }位用户`,
            type: "success",
          });
        } else {
          this.$message({
            message: `成功移除${ _len }个用户，编辑中状态用户移除失败，请稍后重试。`,
            type: "success",
          });
        }
      } else {
        this.$message.error(this.removeCooperatorStateInfo.msg);
      }
    },

    /**
     * 成员选中按钮状态的变化
     * @param {Object} _slen 选中的个数
     */
    selectionStatus(_slen) {
      let _len = this.memberIds.length;
      if (_len === _slen) {
        // this.isIndeterminate = false;
        this.checkAll = true;
      } else if (_slen > 0 && _slen != _len) {
        // this.isIndeterminate = true;
        this.checkAll = false;
      } else {
        // this.isIndeterminate = false;
        this.checkAll = false;
      }
    },
  },
  created() { },
};
/*
         display: flex;
          align-items: center;
          justify-content: center;
*/
</script>

<style lang="scss" >
.is-cooperation-dialog {
  .dialog-footer {
    .btn {
      width: 130px;
    }
  }
  .check {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: right;
    align-items: center;
    .el-checkbox {
      margin-right: 8px;
    }
  }
}

.add-cooperation-dialog {
  .el-dialog {
    border-radius: 4px;
  }
  ::-webkit-scrollbar {
    width: 4px;
    height: 7px;
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ebecf2;
    opacity: 0.65;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    opacity: 0;
  }
  .dialog-title {
    text-align: center;
    font-size: 20px;
    color: rgba(102, 102, 102, 1);
  }

  .el-dialog__header {
    padding-top: 50px;
  }

  .el-dialog__body {
    padding-left: 50px !important;
  }

  .remark {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    margin: 7px 0 11px;
  }

  .team-group {
    display: flex;
    flex-direction: column;
    width: 368px;
    height: 302px;
    background: #fff;
    // border-radius: 10px;

    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-basis: 32px;
      width: 100%;
      border-bottom: 1px solid rgba(234, 236, 247, 1);
    }

    &-body {
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: center;
      overflow-y: auto;
      overflow-x: hidden;
      padding-bottom: 10px;
      border-bottom: 1px solid #eaecf7;
      .el-checkbox-group {
        width: 380px;
      }
      &_cell {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 380px;
        line-height: 58px;
        border-radius: 15px;
        padding-left: 15px;
        cursor: pointer;
        &.cell-fixed {
          margin-left: 0px;
        }
        // &.is-active {
        //     background: rgba(255, 255, 255, 1);
        //     width: 420px;
        //     .selection{
        //         width: 52px;
        //     }
        // }

        .lf {
          display: flex;
          align-items: center;
          justify-content: center;

          .avatar-img {
            border: 2px solid #fff;
          }

          .user-name {
            max-width: 230px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            color: rgba(102, 102, 102, 1);
            margin-left: 16px;
          }
        }

        .selection {
          width: 30px;

          .el-checkbox__input {
            .el-checkbox__inner {
              width: 20px;
              height: 20px;
              // border-radius: 14px;
              &::after {
                height: 11px;
                width: 5px;
                left: 6px;
                top: 1px;
              }
            }
          }
        }
      }
    }
  }

  .cope-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 468px;
    height: 40px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(228, 228, 228, 1);
    border-radius: 13px;
    padding-left: 11px;
    &::before {
      position: absolute;
      display: inline-block;
      content: "";
      width: 370px;
      height: 40px;
    }
    .cope-link {
      color: rgba(170, 169, 169, 1);
      font-size: 14px;
      width: 360px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .cope-btn {
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: rgba(90, 98, 179, 1);
      border-radius: 13px;
      font-size: 14px;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
    }
  }

  .warn-info {
    font-size: 14px;
    color: rgba(170, 169, 169, 1);
    margin-top: 8px;
  }

  .submit-btn {
    width: 140px;
    height: 40px;
    background: #2f58fe;
    border-radius: 4px;
    font-size: 14px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    &:hover {
      background: #3d7dff;
    }
  }

  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 29px auto 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/add-cooperation-dialog.vue